import NewMfaSession from 'client/js/new_mfa_session';
import EmailVerificationCodeInput from 'client/js/email_verification/code_input';
import { BooleanInput, ControlGroup, FormActions, GenericReactForm, StringInput, SubmitButton } from 'client/js/util/form_utils';
import { PageHeader } from 'client/js/util/layout_utils';
import PropTypes from 'prop-types';
import ReCAPTCHA from "react-google-recaptcha";

class ConditionalCaptcha extends React.Component {
  state = { show: false }

  componentDidMount() {
    if (this.context.serverErrors && this.context.serverErrors.captcha)
      this.setState({ show: true });
  }

  componentDidUpdate(previousProps, previousState) {
    if (this.context.serverErrors && this.context.serverErrors.captcha && !previousState.show)
      this.setState({ show: true });
  }

  change = (value) => {
    this.context.formDispatch('value_changed', null, { name: 'recaptcha_response', value: value });
  }

  render () {
    if(!this.state.show)
      return null;

    return (
      <ControlGroup name="captcha" errors={this.context.serverErrors['captcha']}>
        <div className="signup-captcha-text">
          Bitte zeige uns, dass Du ein Mensch bist:
        </div>
        <ReCAPTCHA
          sitekey={this.props.recaptcha_site_key}
          onChange={this.change}
          />
      </ControlGroup>);
  }
}

ConditionalCaptcha.contextTypes = {
  serverErrors: PropTypes.object,
  formDispatch: PropTypes.func
}

class Login extends React.Component {
  state= {}

  dispatch = (action, original_event, data) => {
    if (action != 'form:success')
      return;

    console.log('Login success, data:', data.object);

    if (data.object.device_verification_required) {
      console.log('Device verification required!');
      // Update URL without reload
      window.history.pushState({}, '', '/verify-login-code');
      this.setState({
        logged_in: true,
        device_verification_required: true,
        user_email: data.object.email
      });
      console.log('State set, should render verification now');
      return;
    }

    if (data.object.mfa_required)
      return this.setState({ logged_in: true, mfa_required: true, authentication_factors: data.object.authentication_factors });

    this.setState({ logged_in: true });

    if (this.props.return_url)
      return window.location.href = this.props.return_url;

    const hash_url = window.location.hash.replace('#!', '');

    if (hash_url)
      window.location.href = hash_url;
    else
      window.location.href = '/usercp';
  }

  render() {
    // Show device verification instead of login form
    if (this.state.device_verification_required) {
      return (
        <div>
          <h2>Device Verification Required</h2>
          <p>Email: {this.state.user_email}</p>
          <EmailVerificationCodeInput email={this.state.user_email} />
        </div>
      );
    }

    return (
      <>
        <PageHeader text="Login" />

        <p className="lead">Hast Du noch keinen Account? <a href="/register">Jetzt registrieren</a>!</p>

        <GenericReactForm namespace="user_session" url="/login" dispatch={this.dispatch}>
          <StringInput required name="username" autoComplete="username" label="Benutzername" tabIndex="1" hint={<a href='/hilfe/ich-habe-meinen-benutzernamen-vergessen'>Benutzername vergessen?</a>} />
          <StringInput required name="password" type="password" autoComplete="current-password" label="Passwort" tabIndex="2" hint={<a href="/lostpassword">Passwort vergessen?</a>} />
          <BooleanInput name="remember_me" label="an diesem Computer vier Wochen eingeloggt bleiben" tabIndex="3" />

          <ConditionalCaptcha recaptcha_site_key={this.props.recaptcha_site_key} />

          <FormActions>
            <SubmitButton text="Login" />
          </FormActions>
        </GenericReactForm>

        {this.state.mfa_required && <NewMfaSession return_url={this.props.return_url} authentication_factors={this.state.authentication_factors} default_authentication_factor={this.state.default_authentication_factor} />}
      </>
    );
  }
}

export default Login;
